import { render, staticRenderFns } from "./share-button.vue?vue&type=template&id=388cabd9&scoped=true&"
import script from "./share-button.vue?vue&type=script&lang=js&"
export * from "./share-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388cabd9",
  null
  
)

export default component.exports